var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailRead(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2249_30394",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#00000099"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2249_30394)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.292 18.332L9.75033 14.7904L10.917 13.6237L13.292 15.9987L18.0003 11.2904L19.167 12.457L13.292 18.332ZM10.0003 9.16536L16.667 4.9987H3.33366L10.0003 9.16536ZM10.0003 10.832L3.33366 6.66536V14.9987H7.62533L9.29199 16.6654H3.33366C2.87533 16.6654 2.48296 16.5022 2.15658 16.1758C1.83019 15.8494 1.66699 15.457 1.66699 14.9987V4.9987C1.66699 4.54036 1.83019 4.148 2.15658 3.82161C2.48296 3.49523 2.87533 3.33203 3.33366 3.33203H16.667C17.1253 3.33203 17.5177 3.49523 17.8441 3.82161C18.1705 4.148 18.3337 4.54036 18.3337 4.9987V8.6237L16.667 10.2904V6.66536L10.0003 10.832Z",
    fill: "#00000099",
    fillOpacity: 0.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailRead);
export default __webpack_public_path__ + "static/media/email_read.ecbf147fbbecf95366cc9706746fb0db.svg";
export { ForwardRef as ReactComponent };